/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_table_legend_fl_race_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fastest Lap (+10)`)
};

const es_f1_table_legend_fl_race_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vuelta rápida (+10)`)
};

const de_f1_table_legend_fl_race_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schnellste Runde (+10)`)
};

const nl_f1_table_legend_fl_race_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Snelste ronde (+10)`)
};

const fr_f1_table_legend_fl_race_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tour le plus rapide (+10)`)
};

const it_f1_table_legend_fl_race_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giro veloce (+10)`)
};

const pt_br2_f1_table_legend_fl_race_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volta mais rápida (+10)`)
};

const pt_f1_table_legend_fl_race_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volta mais rápida (+10)`)
};

const ja_f1_table_legend_fl_race_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ファステストラップ (+10)`)
};

const zh_f1_table_legend_fl_race_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最快圈速 (+10)`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_table_legend_fl_race_desc = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_table_legend_fl_race_desc(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_table_legend_fl_race_desc", locale)
	if (locale === "en") return en_f1_table_legend_fl_race_desc(inputs)
	if (locale === "es") return es_f1_table_legend_fl_race_desc(inputs)
	if (locale === "de") return de_f1_table_legend_fl_race_desc(inputs)
	if (locale === "nl") return nl_f1_table_legend_fl_race_desc(inputs)
	if (locale === "fr") return fr_f1_table_legend_fl_race_desc(inputs)
	if (locale === "it") return it_f1_table_legend_fl_race_desc(inputs)
	if (locale === "pt-BR") return pt_br2_f1_table_legend_fl_race_desc(inputs)
	if (locale === "pt") return pt_f1_table_legend_fl_race_desc(inputs)
	if (locale === "ja") return ja_f1_table_legend_fl_race_desc(inputs)
	return zh_f1_table_legend_fl_race_desc(inputs)
};